import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku, SonekiKeisanKmkTypeType } from '@/repositories/keiei-joho/data'
import { ResponseSonekiKeisanSetting, ResponseSonekiKeisanSettingItem } from '@/repositories/keiei-joho/soneki-keisan/data'

type PostParamItem = {
  kmkType: SonekiKeisanKmkTypeType;
  settings: Kamoku[];
}

export interface SonekiKeisanSettingRepository {
  checkCorporationInfoExists (): Promise<boolean>;
  list (): Promise<ResponseSonekiKeisanSetting>;
  save (postParam: ResponseSonekiKeisanSettingItem[]): Promise<void>;
}

export class SonekiKeisanSettingRepositoryImpl implements SonekiKeisanSettingRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/soneki-keisan/setting`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  /**
   * 法人情報の存在チェック
   */
  async checkCorporationInfoExists (): Promise<boolean> {
    const { data } = await this.http.get(`${this.baseUrl}/check-corporation`)
    return data
  }

  async list (): Promise<ResponseSonekiKeisanSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (params: ResponseSonekiKeisanSettingItem[]): Promise<void> {
    const postParam: PostParamItem[] = params.map(p => ({
      kmkType: p.kmkType,
      settings: p.setting.targets
    }))
    await this.http.post(this.baseUrl, postParam)
  }
}
